<div fxLayout="column" fxFlex="0 0 100%" class="hr-notes-wrapper">
    <app-table-filter-expansion-panel
        *ngIf="hasExpansionFilter"
        class="task-expansion"
        #filterExpansion
        [hasTopBorder]="true"
    >
        <ng-container *ngTemplateOutlet="filters"></ng-container>
    </app-table-filter-expansion-panel>
    <ng-container *ngIf="!hasExpansionFilter">
        <ng-container *ngTemplateOutlet="filters"></ng-container>
    </ng-container>
    <mat-table #table [dataSource]="dataSource" matSortActive="created_at" matSortDirection="desc" matSort>
        <ng-container matColumnDef="filename">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Name</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="mobile-label" i18n>Name:</span>
                <app-row-hover-actions [showActions]="columns.includes('tools')">
                    <span class="notes">{{ media.filename ?? media.name }}</span>
                    <button
                        rowHoverAction
                        mat-icon-button
                        [disabled]="media.isProcessing()"
                        (click)="view(media)"
                        matTooltip="View"
                        i18n-matTooltip="@@view"
                        aria-label="View"
                        i18n-aria-label="@@view"
                    >
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                        rowHoverAction
                        mat-icon-button
                        [disabled]="!authUser?.canEditMedia(media)"
                        (click)="edit(media)"
                        matTooltip="Edit"
                        i18n-matTooltip="@@edit"
                        aria-label="Edit"
                        i18n-aria-label="@@edit"
                    >
                        <mat-icon class="material-icons-outlined">edit</mat-icon>
                    </button>
                    <button
                        rowHoverAction
                        mat-icon-button
                        (click)="delete(media.id)"
                        matTooltip="Delete"
                        i18n-matTooltip="@@delete"
                        aria-label="Delete"
                        i18n-aria-label="@@delete"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button
                        rowHoverAction
                        mat-icon-button
                        (click)="copyLink(media.url || media.src)"
                        matTooltip="Copy link"
                        i18n-matTooltip="@@copyLink"
                        aria-label="Copy link"
                        i18n-aria-label="@@copyLink"
                    >
                        <mat-icon>link</mat-icon>
                    </button>
                    <button
                        rowHoverAction
                        mat-icon-button
                        (click)="createMaterial(media)"
                        matTooltip="Create material"
                        i18n-matTooltip="@@createMaterial"
                        aria-label="Create material"
                        i18n-aria-label="@@createMaterial"
                        class="creat-mat"
                    >
                        <mat-icon
                            fxFlex="0 0 auto"
                            color="primary"
                            fontSet="klickdata"
                            fontIcon="kd-icon-document"
                            class="course-plan-icon kd-icon-24 no-shadow"
                        ></mat-icon>
                    </button>
                </app-row-hover-actions>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="created_at">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Created at</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span>{{ media.created_at | kdDateFormat : 'YYYY-MM-DD' }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="updated_at">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Last edit</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span>{{ media.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm' }}</span></mat-cell
            >
        </ng-container>
        <ng-container matColumnDef="author">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Creator</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Creator:</span>
                <span class="author-name" *ngIf="file.author?.name" [matTooltip]="file.author?.name">{{
                    file.author?.name | nameSign
                }}</span>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="priority">
            <mat-header-cell mat-sort-header *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Priority</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let file">
                <span class="mobile-label" i18n>Priority:</span>
                <app-item-change-on-the-fly
                    class="customer-item-not-task {{ file.priority }}"
                    [capitalize]="true"
                    [selectionOptions]="filePrioOptions"
                    [value]="file.priority"
                    (onValueChange)="onSelectPriority(file, $event)"
                ></app-item-change-on-the-fly>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="visibility">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Status</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <div
                    *ngIf="!media.isProcessing()"
                    class="visibility-cell"
                    fxLayoutAlign="start center"
                    fxLayoutGap="5px"
                    [ngClass]="{
                        darkblue: media.visibility == 'public',
                        grey: media.visibility == 'private',
                        iceblue: media.visibility == 'academy'
                    }"
                >
                    <mat-icon
                        [ngClass]="{
                            darkblue: media.visibility == 'public',
                            grey: media.visibility == 'private',
                            iceblue: media.visibility == 'academy'
                        }"
                        [matTooltip]="media.visibility"
                    >
                        {{
                            media.visibility == 'public'
                                ? 'public'
                                : media.visibility == 'private'
                                ? 'public_off'
                                : 'published_with_changes'
                        }}
                    </mat-icon>
                </div>
                <mat-icon class="ai-icon" *ngIf="!!media?.isProcessing()">smart_toy</mat-icon>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="description">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n="@@description">Description</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="description-text">{{ media.description }}</span>
            </mat-cell>

            >
        </ng-container>
        <ng-container matColumnDef="tags">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Tags</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span *ngIf="isMobile" class="mobile-label" i18n> Tags </span>
                <app-table-tags-on-the-fly
                    (click)="$event.stopPropagation()"
                    [tags]="media.tags"
                    (onUpdateTags)="media?.id && updateMediaTags(media, $event)"
                    (onTagClick)="onTagClick($event)"
                ></app-table-tags-on-the-fly>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef>
                <div fxLayoutAlign="start center">
                    <span i18n>Id</span>
                </div>
            </mat-header-cell>
            <mat-cell *matCellDef="let media">
                <span class="mobile-label" i18n>Id:</span>
                <span class="pointer" (click)="copyLink(media.url || media.src)">{{ media.id }}</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tools">
            <mat-header-cell *matHeaderCellDef>
                <ng-container *ngIf="onLoadingAIMedia | async">
                    <div fxLayoutAlign="end center">
                        <mat-icon class="ai-icon">smart_toy</mat-icon>
                    </div>
                </ng-container>
            </mat-header-cell>
            <mat-cell class="btns-actions" *matCellDef="let media">
                <mat-icon
                    i18n-matTooltip="@@favorite"
                    (click)="$event.stopPropagation(); favorite(media)"
                    [ngStyle]="{ color: '#bfd8d0' }"
                    class="grey favorite-button"
                    matTooltip="Favorite"
                    >{{ media.favorite ? 'star' : 'star_border' }}</mat-icon
                >
                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); createMaterial(media)"
                    matTooltip="Create material"
                    mat-icon-button
                    i18n-matTooltip="@@createMaterial"
                    class="creat-mat"
                >
                    <mat-icon
                        fxFlex="0 0 auto"
                        color="primary"
                        fontSet="klickdata"
                        fontIcon="kd-icon-document"
                        class="course-plan-icon kd-icon-24 no-shadow"
                    ></mat-icon>
                </button>
                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); view(media)"
                    [disabled]="media.isProcessing()"
                    matTooltip="View"
                    mat-icon-button
                    i18n-matTooltip="@@view"
                >
                    <mat-icon>visibility</mat-icon>
                </button>

                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); delete(media.id)"
                    matTooltip="Delete"
                    mat-icon-button
                    i18n-matTooltip="@@delete"
                    class="comment-add"
                >
                    <mat-icon>delete</mat-icon>
                </button>
                <button
                    fxHide.gt-sm
                    (click)="$event.stopPropagation(); edit(media)"
                    [disabled]="!authUser?.canEditMedia(media)"
                    matTooltip="Edit"
                    mat-icon-button
                    i18n-matTooltip="@@edit"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <ng-container matColumnDef="min_tools">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell class="btns-actions" *matCellDef="let media">
                <button
                    (click)="$event.stopPropagation(); view(media)"
                    matTooltip="View"
                    mat-icon-button
                    i18n-matTooltip="@@view"
                >
                    <mat-icon>visibility</mat-icon>
                </button>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
        <mat-row
            *matRowDef="let media; columns: columns"
            class="example-element-row"
            (click)="onMediaClick.emit(media)"
        ></mat-row>
    </mat-table>
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"> </mat-paginator>
</div>

<ng-template #loading>
    <div fxLayout="row" fxLayoutAlign="center center" class="spinner-container mt-2">
        <mat-spinner fxFlex="0 0 auto"></mat-spinner>
    </div>
</ng-template>

<ng-template #filters>
    <app-table-filter [filtersTogglesInOnBtn]="true" [inGlobalFilter]="true" color="accent" #filter>
        <app-table-search
            toggleBtnLabel="File"
            i18n-toggleBtnLabel
            [inGlobalFilter]="true"
            class="align-space"
            searchFilterRef
        ></app-table-search>

        <app-tag-chip-search-filter
            [inGlobalFilter]="true"
            fxFlex="50%"
            fxFlex.lt-md="100%"
            fxLayoutAlign="start"
            tagsFilterRef
        ></app-tag-chip-search-filter>
    </app-table-filter>
</ng-template>
